import { motion } from "framer-motion";

// paper-like ticket: main body + perforated stub, each one slightly rotated
export const FilmTicket = ({ id, index, film, year, section, unit, seat, tilt, onClick }) => {
  const num = String(1037 + index * 13);
  return (
    <motion.button
      onClick={onClick}
      data-testid={`teaser-${id}`}
      initial={{ rotate: tilt }}
      animate={{ rotate: tilt }}
      whileHover={{ rotate: 0, y: -10, scale: 1.025 }}
      whileTap={{ scale: 0.99 }}
      transition={{ type: "spring", stiffness: 240, damping: 18 }}
      className="group relative block w-full text-left"
      style={{ transformOrigin: "50% 60%" }}
    >
      <span
        className="relative flex h-full overflow-hidden rounded-[3px] shadow-[0_14px_34px_-14px_rgba(0,0,0,0.9)] transition-shadow duration-500 group-hover:shadow-[0_26px_50px_-14px_rgba(0,0,0,0.95)]"
        style={{
          background:
            "linear-gradient(145deg, #f2e9d2 0%, #e6dabd 45%, #d8c9a6 100%)",
        }}
      >
        {/* paper grain + aging */}
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 mix-blend-multiply opacity-[0.5]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 18% 12%, rgba(120,92,48,0.18), transparent 42%), radial-gradient(circle at 86% 88%, rgba(90,66,30,0.22), transparent 46%)",
          }}
        />
        <span aria-hidden className="pointer-events-none absolute inset-0 border border-black/15 rounded-[3px]" />

        {/* ---------- main body ---------- */}
        <span className="relative flex flex-1 flex-col justify-between gap-5 p-5 sm:gap-7 sm:p-7">
          <span className="flex items-start justify-between gap-3">
            <span className="font-mono2 text-[9px] leading-tight tracking-[0.22em] text-[#6c5a3c]">
              STUDIO 7 · DAVIDE CAMPAGNA
            </span>
            <span className="font-mono2 shrink-0 text-[9px] tracking-[0.2em] text-[#6c5a3c]">N° {num}</span>
          </span>

          <span className="block">
            <span className="font-mono2 block text-[9px] tracking-[0.3em] text-[#9a3b12]">{unit}</span>
            <span className="font-display mt-1.5 block text-lg leading-[1.05] uppercase text-[#1b1711] sm:text-2xl">
              {section}
            </span>
            <span className="mt-2 flex items-baseline gap-2 border-t border-dashed border-[#1b1711]/25 pt-2">
              <span className="font-serif-it truncate text-sm italic text-[#43372a] sm:text-[15px]">{film}</span>
              <span className="font-mono2 shrink-0 text-[10px] tracking-widest text-[#6c5a3c]">({year})</span>
            </span>
          </span>

          <span className="font-mono2 flex items-center gap-3 text-[9px] tracking-[0.2em] text-[#6c5a3c]">
            <span>FILA {String(index + 1).padStart(2, "0")}</span>
            <span className="h-2 w-px bg-[#1b1711]/25" />
            <span>POSTO {seat}</span>
            <span className="h-2 w-px bg-[#1b1711]/25" />
            <span className="text-[#9a3b12] transition-colors duration-500 group-hover:text-[#c2410c]">INGRESSO →</span>
          </span>
        </span>

        {/* ---------- perforation ---------- */}
        <span aria-hidden className="relative w-0 shrink-0">
          <span className="absolute inset-y-2 left-0 border-l-2 border-dashed border-[#1b1711]/35" />
          <span className="absolute -top-[7px] -left-[7px] h-[14px] w-[14px] rounded-full bg-[#0b0c0e]" />
          <span className="absolute -bottom-[7px] -left-[7px] h-[14px] w-[14px] rounded-full bg-[#0b0c0e]" />
        </span>

        {/* ---------- stub ---------- */}
        <span className="relative flex w-[20%] min-w-[104px] flex-col items-center justify-between py-5">
          <span className="font-mono2 text-[8px] tracking-[0.2em] text-[#6c5a3c]">{year}</span>
          <span
            className="font-display text-[11px] uppercase tracking-[0.3em] text-[#1b1711]"
            style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
          >
            Admit One
          </span>
          {/* barcode */}
          <span className="flex h-6 items-end gap-[2px]">
            {[3, 1, 2, 1, 1, 3, 2, 1, 2, 3, 1, 2].map((w, k) => (
              <span
                key={k}
                className="block bg-[#1b1711]/80"
                style={{ width: `${w}px`, height: `${14 + ((k * 7) % 10)}px` }}
              />
            ))}
          </span>
        </span>
      </span>
    </motion.button>
  );
};
